import app from "lib/app";
import me from "models/me";
import pathToRegexp from "path-to-regexp";
import fetch from "lib/fetch";
import siteConfig from "site-config";
import get from "lodash/get";
import { getStore } from "store";
import { activeBrandSet } from "actions/scope";
import { parse } from "query-string";
import { fetchSchemas } from "actions/schemas";

// Scans URL-redirection param and me.last_brand for brandId and sets it as active
export default function (nextState, replace, callback) {
    const redirect = nextState.location.query.redirect || "";

    const re = pathToRegexp("/brand/:brandId/*");
    const hasBrandIdInRedirect = re.test(redirect);
    const hasBrandIdInURL = re.test(global.location.pathname);

    if (me.isSignedIn() && (me.last_brand || hasBrandIdInRedirect) && !hasBrandIdInURL) {
        const parsedRedirect = hasBrandIdInRedirect ? re.exec(redirect) : [];
        let brandToFetch = parsedRedirect.length > 0 ? parsedRedirect[1] : undefined;
        if (!brandToFetch) {
            brandToFetch = parse(location.search || "").brand;
        }

        if (!brandToFetch) {
            brandToFetch = me.last_brand;
        }

        // Either grab it from cache or the server
        app.brands.getOrFetch(brandToFetch, { handle401: true }, (err, model) => {
            if (!err) {
                const store = getStore();
                const activeBrand = model.toJSON();

                store.dispatch(fetchSchemas(model._id)).then(() => {
                    fetch(`${siteConfig.goAPI}/v1/pages/brand/${model._id}`, { brandId: activeBrand._id })
                        .then((response) => {
                            if (response.status >= 300) {
                                throw new Error("Not found");
                            }
                            return response.json();
                        })
                        .then((data) => {
                            activeBrand.has_profile = get(data, "data[0].published", false);
                            store.dispatch(activeBrandSet(activeBrand));
                            callback();
                        })
                        .catch(() => {
                            activeBrand.has_profile = false;
                            store.dispatch(activeBrandSet(activeBrand));
                            callback();
                        });
                });
            } else {
                process.nextTick(() => {
                    callback();
                });
            }
        });
    } else {
        callback();
    }
}
